import {west_row_botanica} from "../views/map";
import {Places_} from "./apis";

export function autocomplete(input: HTMLInputElement, centre?: { lat: number, lng: number }) {
    if (! centre) {
        centre = west_row_botanica;
    }
    const defaultBounds = {
        north: centre.lat + 1,
        south: centre.lat - 1,
        east: centre.lng + 1,
        west: centre.lng - 1,
    };
    const options = {
        bounds: defaultBounds,
        componentRestrictions: { country: "au" },
        fields: ["formatted_address", "geometry"],
        strictBounds: true,
    };

    return Places_.then(() => {
        const autocomplete = new google.maps.places.Autocomplete(input, options);
        return autocomplete;
    });

}
